/**
 * Sliding product-type control.
 * The thumb moves onto the chosen segment, then the page follows.
 * On a phone, a horizontal swipe moves to the next or previous segment.
 */
(function () {
  var MOVE_MS = 380;

  function optionsOf(switchEl) {
    return Array.prototype.slice.call(switchEl.querySelectorAll('.ac-kind-switch__option'));
  }

  function selectedIndex(options) {
    for (var i = 0; i < options.length; i++) {
      if (options[i].classList.contains('is-selected')) return i;
    }
    return 0;
  }

  function placeThumb(switchEl, animate) {
    var thumb = switchEl.querySelector('.ac-kind-switch__thumb');
    var selected = switchEl.querySelector('.ac-kind-switch__option.is-selected');
    if (!thumb || !selected) return;
    if (!animate) thumb.style.transition = 'none';
    thumb.style.width = selected.offsetWidth + 'px';
    thumb.style.height = selected.offsetHeight + 'px';
    thumb.style.transform = 'translate(' + selected.offsetLeft + 'px,' + selected.offsetTop + 'px)';
    if (!animate) {
      thumb.offsetHeight;
      thumb.style.transition = '';
    }
    switchEl.classList.add('is-ready');
  }

  function choose(switchEl, option, navigate) {
    if (!option || option.classList.contains('is-selected')) return;
    optionsOf(switchEl).forEach(function (el) {
      var on = el === option;
      el.classList.toggle('is-selected', on);
      el.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    placeThumb(switchEl, true);
    if (!navigate) return;
    var href = option.getAttribute('href');
    if (!href) return;
    window.setTimeout(function () {
      window.location.assign(href);
    }, MOVE_MS);
  }

  function init(switchEl) {
    if (switchEl.getAttribute('data-ac-kind-ready') === 'true') return;
    switchEl.setAttribute('data-ac-kind-ready', 'true');

    placeThumb(switchEl, false);
    window.addEventListener('resize', function () {
      placeThumb(switchEl, false);
    });

    switchEl.addEventListener('click', function (event) {
      var option = event.target.closest('.ac-kind-switch__option');
      if (!option) return;
      if (switchEl.getAttribute('data-ac-swiped') === 'true') {
        switchEl.removeAttribute('data-ac-swiped');
        event.preventDefault();
        return;
      }
      if (option.classList.contains('is-selected')) return;
      event.preventDefault();
      choose(switchEl, option, true);
    });

    var startX = 0;
    var startY = 0;
    var tracking = false;

    switchEl.addEventListener(
      'touchstart',
      function (event) {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        var touch = event.changedTouches[0];
        startX = touch.clientX;
        startY = touch.clientY;
        tracking = true;
      },
      { passive: true }
    );

    switchEl.addEventListener(
      'touchend',
      function (event) {
        if (!tracking) return;
        tracking = false;
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        var touch = event.changedTouches[0];
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
        if (Math.abs(dx) < 42 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        var options = optionsOf(switchEl);
        var index = selectedIndex(options);
        var forward = document.documentElement.dir === 'rtl' ? dx > 0 : dx < 0;
        var next = forward ? index + 1 : index - 1;
        if (next < 0 || next >= options.length) return;
        switchEl.setAttribute('data-ac-swiped', 'true');
        choose(switchEl, options[next], true);
      },
      { passive: true }
    );
  }

  function boot() {
    document.querySelectorAll('[data-ac-kind-switch]').forEach(init);
    document.addEventListener(
      'toggle',
      function (event) {
        var details = event.target;
        if (!details || !details.open || !details.querySelector) return;
        details.querySelectorAll('[data-ac-kind-switch]').forEach(function (switchEl) {
          placeThumb(switchEl, false);
        });
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
